import { type CSSObject } from '@emotion/react';
import { useTheme } from '@doxyme/ui/theme';

export const useInviteViaTextMessageModalContentStyles = (): {
  consentCheckbox: CSSObject;
  readOnlyTextbox: {
    wrapper: CSSObject;
    defaultMessage: CSSObject;
    staticContent: CSSObject;
  };
} => {
  const theme = useTheme();

  return {
    consentCheckbox: {
      marginLeft: theme.spacing(0),
    },
    readOnlyTextbox: {
      wrapper: {
        position: 'relative',
        overflow: 'hidden',
        borderRadius: theme.shape.radius8,
        outline: '0px solid transparent',
        border: `1px solid transparent`,
        boxShadow: `${theme.typography.inputShadow}, 0 0 0 1px ${theme.input.border.default}`,
        backgroundColor: theme.input.background.disabled,
      },
      defaultMessage: {
        padding: theme.spacing(3),
        color: theme.text.generic.primary,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      },
      staticContent: {
        padding: theme.spacing(3),
        background: theme.input.background.disabled,
        borderTop: `1px solid ${theme.border.primary}`,
        color: theme.text.generic.tertiary,
        whiteSpace: 'pre-wrap',
      },
    },
  };
};
